var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: _vm.classList },
    [
      _c(
        "tube-label",
        {
          staticClass: "t-checkbox__label",
          class: { "t-checkbox__label--image": _vm.imgSrc },
          attrs: { for: _vm.name, size: _vm.size, color: _vm.color },
        },
        [
          !_vm.loading
            ? _c(
                "input",
                _vm._g(
                  {
                    staticClass: "t-checkbox__control",
                    attrs: {
                      id: _vm.name,
                      name: _vm.name,
                      disabled: !_vm.canEmitEvents,
                      readonly: _vm.readonly,
                      type: "checkbox",
                    },
                    domProps: { value: _vm.value, checked: _vm.checked },
                    on: { change: _vm.change },
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checked && _vm.checkedIcon
            ? _c("div", { staticClass: "t-icon t-mar--r-xs" }, [
                _c("i", { class: `mdi ${_vm.checkedIcon} mdi-18px` }),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.checked && _vm.uncheckedIcon
            ? _c("div", { staticClass: "t-icon t-mar--r-xs" }, [
                _c("i", { class: `mdi ${_vm.uncheckedIcon} mdi-18px` }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.imgSrc
            ? _c(
                "span",
                { staticClass: "t-checkbox__value t-checkbox__image" },
                [_c("img", { attrs: { src: _vm.imgSrc, alt: "" } })]
              )
            : _c(
                "span",
                {
                  staticClass: "t-checkbox__value",
                  class: { "t-checkbox__loader": _vm.loading },
                },
                [_vm._t("default"), _vm._v(_vm._s(_vm.label) + "\n    ")],
                2
              ),
        ]
      ),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "t-checkbox__description t-mar--t-ti" }, [
            _vm._v("\n    " + _vm._s(_vm.description) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }